export * from "./WebComponent";
